<template>
    <div class="plan-specs">
        <div class="main-info">
            <div class="plan-header">
                <h3>{{plan.name}}</h3>
                <dropdown v-if="showPlansDropdown" class="plans-dropdown" left>
                    <span slot="toggle" style="width: 13px; cursor: pointer">
                        <i class="fa-light fa-chevron-down"></i>
                    </span>
                    <div 
                    class="dropdown-item"
                    v-for="(otherPlan, index) in plans.filter(p => p.name != plan.name)" 
                    :key="index" 
                    @click="$emit('changed-plan', otherPlan)"
                    >
                        {{otherPlan.name}}
                    </div>
                </dropdown>   
            </div>            

            <p class="description">{{$store.getters.language == 'da' ?  plan.descriptionDa : plan.descriptionEn}}</p>

            <div class="price-info">
                <div v-if="plan.name == 'Enterprise'">
                    <span>{{$t('contact')}}</span>
                    <div class="additional-price-info">
                        <span>{{$t('subscription.lets-meet')}}</span>
                    </div>
                </div>

                <div v-else-if="paymentFrequency == 'month'">
                    <span>{{desiredPrice.currency}}</span>

                    <span>{{parseInt(desiredPrice.price).toLocaleString().replace(/\./g, ' ')}}</span>
                    <span>{{$t('subscription.month-frequency')}}</span>

                            
                    <div class="additional-price-info">
                        <span>{{$t('subscription.annual-price')}}</span>
                        <span>{{desiredPrice.currency + ' '}}</span>
                        <span>{{parseInt(desiredPrice.price * 12).toLocaleString().replace(/\./g, ' ')}}</span>
                        <span>{{$t('subscription.year-frequency')}}</span>
                    </div>

                </div>
                <div v-else>
                    <span>{{desiredPrice.currency}}</span>
                    <span>{{monthlyPriceForAnnual}}</span>
                    <span>{{$t('subscription.month-frequency')}}</span>
                    
                        <!-- <span>{{$t('subscription.annual-price') + desiredPrice.currency + ' ' + parseInt(desiredPrice.price).toLocaleString().replace(/\./g, ' ') +  $t('subscription.year-frequency')}}</span> -->
                    <div class="additional-price-info">
                        <span>{{$t('subscription.annual-price')}}</span> 
                        <span>{{desiredPrice.currency + ' '}}</span> 
                        <span>{{parseInt(desiredPrice.price).toLocaleString().replace(/\./g, ' ')}}</span>  
                        <span>{{$t('subscription.year-frequency')}}</span>
                    </div>
                </div>
                    <slot ref="cta" name="cta"> </slot>
                    <slot ref="current" name="current"> </slot>
            </div>
            <slot ref="quote" name="quote" class="quote"> </slot>
        </div>
    
        <div class="additional-plan-info">
            <div v-if="plan.planName == 'Enterprise'">
                    <p><i class="fa-light fa-sync-alt"></i><span>{{plan.ids.toLocaleString().replace(/\./g, ' ')}} +</span>  {{$t('subscription.generations')}} </p>
                    <p>	<i class="fa-light fa-file-export"></i><span>{{$t('subscription.publications')}} {{$t('subscription.enterprise-publications')}}</span> </p>
                    <p><i class="fa-light fa-headset"></i><span>{{$store.getters.language == 'da' ? plan.supportDa : plan.supportEn}}</span> </p>
                    <p><i class="fa-light fa-play-circle"></i><span>{{$t('subscription.enterprise-onboarding')}}</span></p>
                    <p> <i class="fa-light fa-trophy"></i> <span>{{$t('subscription.enterprise-special')}}</span> </p>
            </div>
            <div v-else>
                <p><i class="fa-light fa-sync-alt"></i><span>{{plan.ids.toLocaleString().replace(/\./g, ' ')}} </span>  {{$t('subscription.generations')}} </p>
                <!-- <p><i class="fa-light fa-file"></i><span>{{plan.templates}}</span> {{plan.templates == 1 ? $t('subscription.template') : $t('subscription.templates')}} </p> -->
                <!-- <p><i class="fa-light fa-database"></i><span>{{plan.integrations}}</span> {{plan.integrations == 1 ?  $t('subscription.integration') : $t('subscription.integrations')}} </p> -->
                <p>	<i class="fa-light fa-file-export"></i><span>{{plan.publications}}</span> {{plan.publications == 1 ?  $t('subscription.publication') : $t('subscription.publications')}} </p>
                <!-- <p><i class="fas fa-globe"></i><span>{{plan.languages}}</span> {{$t('subscription.languages')}} </p> -->
                <!-- <p><i class="fa-light fa-user"></i><span>{{plan.users}}</span> {{$t('subscription.users')}} </p> -->
                <p><i class="fa-light fa-headset"></i><span>{{$store.getters.language == 'da' ? plan.supportDa : plan.supportEn}}</span> </p>
                <p><i class="fa-light fa-play-circle"></i><span>{{plan.workshopHours ? plan.workshopHours + ' '+ $t('subscription.workshop')+ ' +' : ''}} {{$store.getters.language == 'da' ? plan.onboardingDa : plan.onboardingEn}} </span></p>
                <!-- <p><span>{{plan.workshopHours}}</span> {{$t('subscription.workshop')}} </p> -->
                <!-- <p v-if="plan.planName == 'Medium'"><i class="fa-light fa-star"></i><span>{{$t('subscription.popular')}}</span>  </p> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
name: 'SubscriptionPlan',
  data() {
    return {

    };
  },
  props:{
      plan: Object,
      plans: Array,
      currentCurrency: String,
      paymentFrequency: {
          type: String,
          default: 'month'  
      },
      showPlansDropdown: {
          type: Boolean,
          default: false
      },
      planIsCurrent: Boolean
  },
  computed:{
    tests(){
        return this.plan.planterms_set
    },
    test(){
        return this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type || plan.intervalType == this.paymentFrequency )
    },
    desiredPrice(){
        // priceData.monthlyPriceForAnnual = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type == "year")
        
        // console.log(this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.intervalType == this.paymentFrequency ) )
        
        // if(!priceData){
        //     priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency ) 
        // }
        
        // let priceDataSubscribed = {currency: this.plan.terms.currency, price: this.plan.terms.price, interval_type: this.plan.terms.interval_type}
        if(this.plan.planterms_set){
            let priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type || plan.intervalType == this.paymentFrequency )      
            return priceData 
        } else return {currency: this.plan.currency, price: this.plan.price}
    },
    monthlyPriceForAnnual(){
        if(this.plan.planterms_set){
            let monthlyPrice = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type || plan.intervalType == "year" ) 
                monthlyPrice = parseInt(monthlyPrice.price) / 12
                monthlyPrice = parseInt(monthlyPrice).toLocaleString().replace(/\./g, ' ')
            return  monthlyPrice
        } else return this.plan.price.toLocaleString().replace(/\./g, ' ')
    },
  }

};
</script>

<style lang="less">
    .plan-specs{
        position: relative;
           .description{
               font-size: 12px;
           }    
            .main-info{
                display: grid;
                // grid-template-rows: auto minmax(60px, auto) 40px;
                grid-template-rows: auto minmax(60px, auto) minmax(40px, auto);
                margin-bottom: 20px;
                .plan-header{
                    display: flex;
                    justify-content: space-between;
                }
               .price-info{
                    font-weight: bold;
                    font-size: 18px;
                    border-bottom: 1px solid lightgray;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    span:first-of-type{
                        margin-right: 8px;
                    }
                    button{
                        margin-bottom: 12px;
                    }
                }        
            }
            .quote{
                font-size: 12px;
                opacity: 0.5;
                font-weight: 500;
                color: #3D464A;
            }
            h3{
                font-size: 24px !important;
                letter-spacing: 1px;
            }
            .additional-plan-info{
                font-size: 14px;
                p{
                    display: flex;
                }
                svg{
                    width: 18px;
                    font-size: 18px;
                    margin-right: 20px;
                }
                span{
                    margin-right: 4px;
                    font-weight: 600;
                }
            }
            .additional-price-info{
                font-size: 12px;
                opacity: .5;
                font-weight: 500;
                color: #3D464A;
            }
            .current-plan{
                background: #fff;
                border: 1px solid var(--flame);
                width: 100%;
                padding: 6px 12px;
                text-align: center;
                font-size: 12px;
                margin-bottom: 12px;
                font-weight: 500;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            }
        }

</style>
